import * as React from "react"
import { useTranslation } from "react-i18next"

import Details from "Catalog/Edit/shared/components/Details"
import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import StatefulField from "shared/components/StatefulField"
import useEditor from "shared/hooks/useEditor"
import useNavigateNoUpdate from "shared/hooks/useNavigateNoUpdate"
import { ICharge } from "shared/hubrise/models"

import Commands from "./Commands"

const Content = ({ charge }: { charge: ICharge }): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigateNoUpdate()

  const { catalogNavigation } = useCatalogNavigation()

  const {
    editor,
    catalog: { currency },
  } = useEditor()

  const handleChange =
    <TField extends keyof ICharge>(field: TField) =>
    (value: ICharge[TField]) =>
      editor.charge.update(charge.id, field, value)

  return (
    <>
      <Details.Topbar
        commands={<Commands charge={charge} />}
        onClose={() => navigate(catalogNavigation.editPath("charges"))}
      >
        <StatefulField.Title
          name="charge-name"
          initialValue={charge.name}
          placeholder={t("charge.name.placeholder")}
          onChange={handleChange("name")}
          validate={(name) => (name.length === 0 ? t("validations.not_empty") : undefined)}
        />
      </Details.Topbar>

      <StatefulField.Select
        name="charge-type"
        initialValue={[charge.type]}
        label={t("charge.type.label")}
        withMargin
        onChange={(types) => editor.charge.update(charge.id, "type", types[0] as ICharge["type"])}
        options={[
          { label: t("charge.type.delivery"), value: "delivery" },
          { label: t("charge.type.payment_fee"), value: "payment_fee" },
          { label: t("charge.type.tip"), value: "tip" },
          { label: t("charge.type.tax"), value: "tax" },
          { label: t("charge.type.other"), value: "other" },
        ]}
        searchable={false}
      />

      <StatefulField.Input
        name="charge-ref"
        initialValue={charge.ref}
        label={t("charge.ref.label")}
        withMargin
        onChange={handleChange("ref")}
      />

      <StatefulField.MoneyInput
        name="charge-price"
        initialValue={charge.price}
        label={t("charge.price.label")}
        withMargin
        placeholder={t("charge.price.placeholder")}
        onChange={handleChange("price")}
        currency={currency}
      />
    </>
  )
}

export default React.memo(Content)
